import React, { useState } from "react";
import { Phone, MessageCircle, X } from "lucide-react";

/**
 * Floating contact widget pinned to bottom-left.
 * Exposes phone call + WhatsApp chat for customer support.
 */
const PHONE_E164 = "+41793966660";
const PHONE_DISPLAY = "079 396 66 60";
const WHATSAPP_NUMBER = "41793966660"; // no + for wa.me URL

const ContactWidget = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-4 left-4 z-40" data-testid="contact-widget">
      {open && (
        <div
          className="mb-3 bg-white border-2 border-[var(--rs-primary)] shadow-2xl overflow-hidden w-72"
          data-testid="contact-panel"
        >
          <div className="bg-[var(--rs-primary)] text-white px-4 py-3 flex items-center justify-between">
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/60">NIVARA</div>
              <div className="font-[Chivo] font-black text-lg leading-none mt-1">Kontakt & Fragen</div>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="text-white/70 hover:text-white"
              aria-label="schliessen"
              data-testid="contact-close"
            >
              <X size={18} />
            </button>
          </div>

          <div className="p-4 space-y-2">
            <a
              href={`tel:${PHONE_E164}`}
              className="flex items-center gap-3 p-3 border-2 border-[var(--rs-border)] hover:border-[var(--rs-primary)] hover:bg-[var(--rs-surface)] transition-colors group"
              data-testid="contact-phone-btn"
            >
              <div className="w-10 h-10 bg-[var(--rs-primary)] text-white flex items-center justify-center flex-shrink-0">
                <Phone size={18} />
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--rs-text-muted)]">Anrufen</div>
                <div className="font-bold text-[var(--rs-primary)]">{PHONE_DISPLAY}</div>
              </div>
            </a>

            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
                "Hallo NIVARA, ich habe eine Frage zu meiner Buchung."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 border-2 border-[var(--rs-border)] hover:border-[#25D366] hover:bg-[#25D366]/5 transition-colors"
              data-testid="contact-whatsapp-btn"
            >
              <div className="w-10 h-10 bg-[#25D366] text-white flex items-center justify-center flex-shrink-0">
                <MessageCircle size={18} />
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--rs-text-muted)]">WhatsApp</div>
                <div className="font-bold text-[#128C7E]">{PHONE_DISPLAY}</div>
              </div>
            </a>
          </div>

          <div className="px-4 pb-4 text-[11px] text-[var(--rs-text-muted)] leading-relaxed">
            Bei Fragen zu Buchung, Abholung oder Rückgabe sind wir persönlich für Sie da.
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="bg-[var(--rs-cta)] hover:bg-[var(--rs-cta-hover)] text-white shadow-2xl flex items-center justify-center gap-2 transition-all hover:scale-105 font-bold uppercase tracking-[0.2em] w-12 h-12 rounded-full sm:w-auto sm:h-auto sm:rounded-none sm:px-4 sm:py-3 sm:text-[11px]"
        data-testid="contact-toggle-btn"
        aria-label="Kontakt öffnen"
      >
        {open ? <X size={18} /> : <Phone size={18} />}
        <span className="hidden sm:inline">Kontakt</span>
      </button>
    </div>
  );
};

export default ContactWidget;
